'use strict';

import pixel from '../pixel/pixel';
import tools from '../tools/tools';

export default class Reporter {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  getBaseUrl() {
    return this.baseUrl;
  }

  report(data) {
    if (!data) {
      return null;
    }

    return pixel.fetch(this.baseUrl + '?' + tools.mapToQuery(data));
  }
}



// WEBPACK FOOTER //
// ./reporter/reporter.js